<!--
 * @Author: 孙照
 * @LastEditTime: 2023-02-02 11:20:27
 * @Description: 次要弹框
 * @FilePath: \dsnd_monitor\src\components\secondaryModal\index.vue
-->
<template>
  <div class="pub-secondary-modal" v-if="visible">
    <div class="modal-mask-sec">
      <div class="modal-close" @click.stop="closeVisible(false)">
        <img src="@/assets/images/modalCloseIcon.png" alt="">
      </div>
      <div class="modal-content">
        <slot name="content"></slot>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'pubSecondaryModal',
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
  },
  watch: {

  },
  methods: {
    closeVisible(flag) {
      this.$emit('change-visible', flag);
    },
  },
};
</script>

<style lang="less" scoped>
.pub-secondary-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  z-index: 99;
  &::-webkit-scrollbar { width: 0 !important }
  .modal-mask-sec {
    z-index: 99;
    width: 1920px;
    height: 1080px;
    background: rgba(0,0,0,0.6);
    position: relative;
    .modal-close {
      z-index: 99;
      width: 30px;
      height: 30px;
      position: absolute;
      top: 114px;
      right: 383px;
      cursor: pointer;
      img {
        width: 30px;
        height: 30px;
      }
    }
    .modal-content {
      position: absolute;
      top: 156px;
      left: 50%;
      transform: translateX(-50%);
      width: 1186px;
      height: 794px;
      .backgroundImage('@/assets/images/secondaryDialogBg.png');
    }

  }
}
</style>
